import dayjs from "dayjs";
import store from "../store";

const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');

dayjs.extend(utc)
dayjs.extend(timezone)

const tz = "Asia/Istanbul"

export default {
  install(Vue) {
    const language = store.state.Language.apiLanguage;
    if (language) {
      const lang = language.slice(0, -3);

      require(`dayjs/locale/${lang}`);

      Vue.prototype.$dayjs = date => dayjs(date).tz(tz);
    }
  }
};
